import { CollectionsApiClient } from '@fourthwall/services/dist/CollectionsApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useCreateCollectionMutation = createMutationHook(
  CollectionsApiClient.createCollection,
  {
    mutationKey: ['createCollection'],
  },
)
